Bundle = {
  Defaults: {
    // Convenience functions to reference various important divs within the build.
    // If you structure your HTML differently than our example build, you can alter these
    // functions to reference the correct divs.
    getBundleDiv: function () {
      return $(".bundle");
    },
    getBundleGridDiv: function () {
      return Bundle.Defaults.getBundleDiv().find(".bundle-grid");
    },
    getBundleDetailsDiv: function () {
      return Bundle.Defaults.getBundleDiv().find(".bundle-details");
    },
    getAddToCartDiv: function () {
      return $("#bundle-add-to-cart");
    },
    getWidget: function () {
      return ReChargeWidget.getWidgets()[0];
    },
  },
  Utils: {
    // Utilty functions used throughout the rest of the build
    generateGuid: function () {
      // Generates a unique guid to be used for the bundle_id
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    calculateBundleQuantity: function ($bundle) {
      // Calculates the total number of items selected on the page.
      // Will loop through all grid items and sum up the total bundle
      // quantity based on the data-qty attribute of each variant.
      // 1.) $bundle = top level bundle div of the grid matrix
      var bundle_qty = 0;
      $bundle.find(".bundle-item").each(function () {
        bundle_qty += Number($(this).attr("data-qty"));
      });
      return bundle_qty;
    },
    isSubscription: function (widget) {
      // Determines whether the user has selected the One-time purchase
      // or Subscribe and Save option on the ReCharge widget
      return widget.subscriptionActive;
    },
    updateBundleQuantity: function ($item, increment) {
      // Main function to handle quantity manipulation. Pass in the grid
      // item along with the quantity to increment or decrement. Then it will
      // determine the current and new item/bundle quantities. Then it checks
      // constraints, and if valid, update all necessary data attributes,
      // interface output, and enable/disable any buttons.
      // 1.) $item = the clicked plus or minus .bundle-item parent div
      // 2.) increment = the amount to increase or decrease the quantity
      // Get bundle parent reference and min/max numbers
      var $bundle = $item.closest(".bundle-grid");
      var bundle_min = Number($bundle.attr("data-bundle-min"));
      var bundle_max = Number($bundle.attr("data-bundle-max"));
      // Calculate current item and bundle quantity
      var bundle_qty = Bundle.Utils.calculateBundleQuantity($bundle);
      var item_qty = Number($item.attr("data-qty"));
      // Calculate the new bundle and item quantities with the increment added
      var new_bundle_qty = bundle_qty + parseInt(increment);
      var new_item_qty = item_qty + parseInt(increment);
      // Check constraints to make sure we can perform the action


      if (
        Bundle.Constraints.isItemGreaterThanZero(new_item_qty) &&
        Bundle.Constraints.isBundleGreaterThanMin(new_bundle_qty, bundle_min) &&
        Bundle.Constraints.isBundleLessThanMax(new_bundle_qty, bundle_max)
      ) {
        //Update quantities
        $item.attr("data-qty", new_item_qty);
        
        let quantityLeft = (bundle_max - new_bundle_qty);

        if (new_item_qty > 0) {
          $item.parent().addClass('active');
          $item.find(".bundle_quantity").html(new_item_qty);
        } else {
          $item.parent().removeClass('active');
          $item.find(".bundle_quantity").html("&nbsp;");
        }

        $('.Bundle__form').attr('data-color', $item.data('color'))
        

        $(".current-qty").html(new_bundle_qty);
        //Toggle the Add to Cart Button if max items is reached
        var is_disabled = Bundle.Constraints.isBundleEqualMax(
          new_bundle_qty,
          bundle_max
        )
          ? false
          : true;
        Bundle.Defaults.getAddToCartDiv().prop("disabled", is_disabled);
        //Update plus/minus button's disabled property
        $bundle.find(".bundle-item").each(function () {
          var item_qty = $(this).attr("data-qty");
          var is_disabled = Bundle.Constraints.isBundleEqualParam(
            new_bundle_qty,
            bundle_max
          )
            ? true
            : false;
          $(this).find(".plus").find(".btn").prop("disabled", is_disabled);
          var is_disabled =
            Bundle.Constraints.isBundleEqualParam(new_bundle_qty, bundle_min) ||
            Bundle.Constraints.isBundleEqualParam(item_qty, 0)
              ? true
              : false;
          $(this).find(".minus").find(".btn").prop("disabled", is_disabled);
        });



        let active_items = $('.bundle-product-grid-item.active');


        $('.bundle-preview--selected-items').html("");

        let newElem = $('<div class="bundle-selected-items bundle-selected-items-overview" />');
        newElem.addClass('blue');
        newElem.html('<span>Total<br>'+ new_bundle_qty +'</span>');
        $('.bundle-preview--selected-items').append(newElem);

        
        active_items.each(function(){
          let newElem = $('<div class="bundle-selected-items" />');
          let quantity = $(this).find('.bundle-item').attr('data-qty');
          let color = $(this).find('.bundle-item').data('color');
          console.log(quantity);
          newElem.addClass(color);
          newElem.html(quantity);
          $('.bundle-preview--selected-items').append(newElem);
        });


        if (quantityLeft > 0) {
          $('.bundle-preview--next a').html((quantityLeft) + " MORE CASE" + (quantityLeft > 1 ? "S" : ""));
          $('.bundle-preview--next a').attr('disabled', true).removeClass('my-class-name');
          
          $('.bundle-preview--next').unbind('click');
        } else {
          $('.bundle-preview--next a').attr('disabled', false).html("CONTINUE").addClass('my-class-name');

          $('.bundle-preview--next').on('click', function(){
            $('.Bundle__nextpage').show();
            $('.product-mix__wrap').hide();



            let ActiveTrack = $('.bundle-tracker__step.active');
            if (ActiveTrack.data('step') == 2) {
              $("#bundle-add-to-cart").trigger('click');
              // final process for add to cart 
            } else {
              let Tracker = $('.bundle-tracker__step');
              Tracker.removeClass('active');
              Tracker.last().addClass('active');
              $('.rc-option__subsave .rc-option__text').html('Flexible Subscription');
              $("body, html").animate({scrollTop: 0}, 300)
            }
            
          })

          if ($(window).width() < 900) {

          } else {
            //$('.icon__Open__subscribe').trigger('click')
          }
        }

      }

    },
    updatePrice: function () {
      var widget = Bundle.Defaults.getWidget();
      var is_subscription = Bundle.Utils.isSubscription(widget);
      var $bundle = Bundle.Defaults.getBundleGridDiv();
      var bundle_subscription_price = $bundle.attr("data-subscription-price");
      var bundle_onetime_price = $bundle.attr("data-onetime-price");


      var bundle_subscription_item_price = parseInt( $bundle.attr("data-subscription-item-price"));
      var bundle_onetime_item_price =  parseFloat($bundle.attr("data-onetime-item-price").replace(",", ".")).toFixed(2);

      
      //If subscription option is clicked, display discounted subscription price
      //Otherwise, display full bundle price

      var qty = Bundle.Utils.calculateBundleQuantity($bundle);

      $('.rc_widget__price--subsave').html("£" + bundle_subscription_item_price * qty);
      $('.rc_widget__price--onetime').html("£" + bundle_onetime_item_price * qty);
      
      if (is_subscription) {
        $(".bundle-price").html(bundle_subscription_price);
        $(".Bundle__total-price").html("£" + bundle_subscription_item_price * qty);
        $('.free-delivery-text').show().css("display", "inline-block");
      } else {
        $(".bundle-price").html(bundle_onetime_price);
        $(".Bundle__total-price").html("£" + bundle_onetime_item_price * qty);
        $('.free-delivery-text').show().css("display", "inline-block");
      }

        if (qty) {
          $('.Bundle__total-label').html("Total").css("position", "absolute");
        } else {
          $('.Bundle__total-label').html("Choose your flavours").css("position", "absolute");
          $(".Bundle__total-price").html("");
        }
      
    },
  },
  Constraints: {
    // Requirement functions to determine whether the user is
    // performing an action that is forbidden
    isItemGreaterThanZero: function (qty) {
      // Check that the item quantity doesn't fall below zero
      // 1.) qty = item quantity of the variant
      if (qty < 0) {
        console.log("Item quantity cannot be less than 0.");
        return false;
      }
      return true;
    },
    isBundleGreaterThanMin: function (qty, min) {
      // Check that the bundle quantity doesn't fall below the minimum quantity
      // 1.) qty = total bundle quantity of the page
      // 2.) min = minimum value the bundle quantity can't fall below
      if (qty < min) {
        console.log("Quantity cannot be less than the minimum.");
        return false;
      }
      return true;
    },
    isBundleLessThanMax: function (qty, max) {
      // Check that the bundle quantity doesn't go above the maximum quantity
      // 1.) qty = total bundle quantity of the page
      // 2.) max = maximum value the bundle quantity can't rise above
      if (qty > max) {
        console.log("Quantity cannot be greater than maximum.");
        return false;
      }
      return true;
    },
    isBundleEqualMax: function (qty, max) {
      // Check that the bundle quantity is equal to the maximum quantity
      // 1.) qty = total bundle quantity of the page
      // 2.) max = maximum value the bundle quantity can't rise above
      return qty == max ? true : false;
    },
    isBundleEqualParam: function (qty, param) {
      // Check that the bundle quantity is equal to param
      // 1.) qty = total bundle quantity of the page
      // 2.) param = value to compare qty against
      return qty == param ? true : false;
    },
  },
  Cart: {
    // Functions used when adding the bundle to the cart and removing a bundle from the cart
    processAddToCart: function () {
      // Top level function tied to the Add to Cart button.
      // Function will check constraints to make sure we can
      // add the bundle to the cart, then it will generate
      // the cart array and make the AJAX call to Shopify's API.
      // Once added to cart, we redirect to the /cart page.
      // Get bundle parent, bundle max value, and total bundle quantity values
      var $bundle = Bundle.Defaults.getBundleGridDiv();
      var qty = Bundle.Utils.calculateBundleQuantity($bundle);
      var bundle_max = Number($bundle.attr("data-bundle-max"));
      // Ensure we can process the cart, and if not, break out of function
      if (!Bundle.Constraints.isBundleEqualMax(qty, bundle_max)) {
        console.log(
          "Cannot process Add to Cart. Qty does not equal max total."
        );
        return;
      }
      //Generate the product array to pass to AJAX call
      var widget = Bundle.Defaults.getWidget();
      var items = Bundle.Cart.generateCart($bundle, widget);
      // Ensure there are items to add to cart, and if so, make
      // API call and redirect to /cart page

      console.log(items);
      if (items.length > 0) {
        Bundle.Cart.processToCart(items);
      } else {
        console.log("No items available to add to cart.");
      }
    },
    generateCart: function ($bundle, widget) {
      // Check that the bundle quantity is equal to param
      // 1.) $bundle = top level bundle div of the grid matrix
      // 2.) widget = the ReCharge widget object tied to the page
      var cart = [];
      var is_subscription = Bundle.Utils.isSubscription(widget);
      // bundle_id that we will pass to each product object as a
      // line item property to associate them to this bundle
      var bundle_id = Bundle.Utils.generateGuid();
      // Determine whether the user has the One-time purchase or
      // Subscribe & Save purchase type option selected. If Subscribe
      // & Save, generate the shipping interval unit_type and frequency
      // that are passed through on ReCharge orders.

      if (is_subscription) {
        var selling_plan = widget.state.sellingPlanId;
      }
      // Loop through each product grid item
      $bundle.find(".bundle-item").each(function () {
        // If item's quantity is greater than 0, add
        // to the cart array
        var qty = $(this).attr("data-qty");
        if (Number(qty) > 0) {
          var variant_id = $(this).attr("data-variant-id");
          // Pass the variant_id, quantity, and bundle_id
          // for each grid item we process
          var item = {
            id: variant_id,
            quantity: qty,
            properties: {
              bundle_id: bundle_id,
            },
          };
          // If this is a Subscribe & Save bundle, pass in the
          // ReCharge properties too
          if (is_subscription) {
            item["selling_plan"] = selling_plan;
          }
          cart.push(item);
        }
      });
      return cart;
    },
    processToCart: function (items) {
      // Makes API call to add bundle items to cart. If the
      // call is successful, redirect to /cart page. If error,
      // display the error to the console.
      // 1.) items = the product array to be passed to the Shopify
      // API. Bundle.Cart.generateCart() function builds this array.

      console.log(items);
      
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: items,
        },
        dataType: "json",
        success: function () {
          //window.location.href = "/cart";
          CartJS.getCart();
          openModal();

        },
        error: function (jqXHR, text_status, error_thrown) {
          console.log(text_status, error_thrown);
        },
      });
    },
    removeBundleItems: function (bundle_id) {
      // Removes all bundle items from cart when user clicks remove on cart page
      // Get current cart contents
      jQuery.getJSON("/cart.js", function (cart) {
        // Create new updates object to send to cart update AJAX call
        // Loop through each cart item
        // If the item's bundle id matches the id passed in,
        // add the cart item key along with quantity of 0 to the data object
        let bundle_items = [];
        let qty = 0;
        let data = { updates: {} };
        cart.items.forEach((item, i) => {
          if (
            item.properties !== null &&
            item.properties.bundle_id !== null &&
            item.properties.bundle_id == bundle_id
          ) {
            data.updates[item.key] = 0;
          }
        });
        // API call to update the cart contents and set the bundle item quantities to 0
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: data,
          dataType: "json",
          success: function () {
            CartJS.getCart();
          },
        });
      });
    },
  },
  init: function () {
    // Initialization function to register all click handlers
    // Registers each grid item's minus button
    $("body").on("click", ".bundle .minus", function () {
      var item = $(this).closest(".bundle-item");
      Bundle.Utils.updateBundleQuantity(item, -1);
      Bundle.Utils.updatePrice();
    });
    // Registers each grid item's plus button
    $("body").on("click", ".bundle .plus", function () {
      var item = $(this).closest(".bundle-item");
      Bundle.Utils.updateBundleQuantity(item, 1);
      Bundle.Utils.updatePrice();
    });
    // Registers the page's Add to Cart button
    $("body").on("click", "#bundle-add-to-cart", function (e) {
      e.preventDefault();
      Bundle.Cart.processAddToCart();
    });



    $("body").on("click", ".icon__Open__subscribe", function () {
      $(".product-form__item--submit__Sidebar").addClass("vissible");
      $(".Sibebar__Overlay").addClass("visible");
      Bundle.Utils.updatePrice();
    });

    $("body").on("click", ".product-form__cart-submit, .Sibebar__Overlay", function () {
      $(".product-form__item--submit__Sidebar").removeClass("vissible"); 
      $(".Sibebar__Overlay").removeClass("visible");
      Bundle.Utils.updatePrice();
    });


    $(window).on("load", function(){
      Bundle.Utils.updatePrice();
    })
    // Registers function to handle price change when user changes subscription vs one-time
    $("body").on("change", ".rc-widget input", function () {
      Bundle.Utils.updatePrice();

    });
    // Registers each cart bundle item's remove button
    $("body").on("click", ".cart__remove-bundle", function () {
      var bundle_id = $(this)
        .closest(".cart__remove-bundle")
        .attr("data-bundle-id");

      CartJS.getCart();
      Bundle.Cart.removeBundleItems(bundle_id);
    });



    if ($(window).width() < 700) {
      $('.Mobile__Mix').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      });
    }

    let StepTrackers = $('.bundle-tracker__step');

    StepTrackers.on('click', function(){
      let isActive = $(this).hasClass('active'),
          steps = $(this).data('step');

          if (!isActive && steps == 1) {
            StepTrackers.removeClass('active');
            $(this).addClass('active');

            
            $('.Bundle__nextpage').hide();
            $('.product-mix__wrap').show();
          } else if(!isActive && steps == 2) {
            $('.bundle-preview--next a').trigger('click')
          }
    });


    var flavours = $('.flavour__list--item .FlavourIncluded');

    flavours.on('click', function (){

        var self = $(this),
            parent = self.parent(),
            grandParent = parent.parent(),
            qtySelector = parent.find('.product-flavour__qty'),
            isActive = self.is(':checked');
        
        var active_flavours = $('.flavour__list--item input[type=checkbox]:checked');

        var quantity = parent.find('.bundle_quantity').html();
        var plusQuantity = parent.find('.product-form-input-count.plus');
        var minusQuantity = parent.find('.product-form-input-count.minus');
          
        if (active_flavours.length >= 5) {
            alert('you can only select 4 flavours');
            return false;
        }
        
        if (isActive) {
            if (quantity == 0) plusQuantity.click();
            //qtySelector.attr('name', qtySelector.data('name'));;
        } else {
            //qtySelector.removeAttr('name');;
            minusQuantity.click();
        }

      Bundle.Utils.updatePrice();

    });
  },
};
// Call the init() function to register click handlers
Bundle.init();
